import { ChangeDetectorRef, Component, Inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';

//Environments
import { environment } from '../../../../environments/environment';
import { MapService } from 'src/app/services/map.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-mapa-establecimientos',
  templateUrl: './mapa-establecimientos.component.html',
  styleUrls: ['./mapa-establecimientos.component.css']
})
export class MapaEstablecimientosComponent{

  lat: number = 40.416969;
  lng: number = -3.703215;
  zoom: number = 6;
  est_img_path: string = "";
  establecimientosData: any = [];
  userData: any = [];
  errorMessage : string = "";
  permiso: boolean = false;

  private establecimientoSubscription: Subscription | undefined;

  private currentInfoWindow: google.maps.InfoWindow | null = null;

  urlBase: string = "";
  map: any;
  markers: google.maps.Marker[] = [];

  constructor(private deviceService: DeviceService, private userDataService: UserDataService, public dialog: MatDialog, private error429: Error429Service, private mapService: MapService, private ngZone: NgZone){
    this.userData = this.userDataService.getUserData();
    this.urlBase = environment.urlNonce;
    if(this.userData.pro_id == 4 || this.userData.pro_id == 1){
      this.permiso = true;
    }
  }

  ngAfterViewInit(): void {
    this.establecimientoSubscription = this.deviceService.getDevicesAllDataNew().subscribe({
      next: resp =>{
        this.establecimientosData = resp;
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete: ()=>{
        this.mapService.loadMapScript(this.initMap.bind(this));
      }
    });
  }

  async initMap(): Promise<void> {
    const mapElement = document.getElementById('map');
    // Verificar si el elemento existe antes de intentar trabajar con él
    if (mapElement) {
      const mapOptions = {
        center: { lat: this.lat, lng: this.lng },
        zoom: this.zoom,
      };
      const map = new google.maps.Map(mapElement, mapOptions);
      const infowindow = new google.maps.InfoWindow();
      
      // Lógica para agregar marcadores al mapa
      this.establecimientosData.forEach((establecimiento: any) => {
        const marker = new google.maps.Marker({
          position: { lat: establecimiento.est_lat, lng: establecimiento.est_lng },
          map: map,
          title: establecimiento.est_name,
          icon: {
            url: 'assets/images/icon-android-nuevo.png',
            scaledSize: new google.maps.Size(40, 40),
            anchor: new google.maps.Point(20, 40)
          },
        });
        // Evento de clic en el marcador
        marker.addListener('click', () => {
          this.ngZone.run(() => {
            this.abrirDialogoEstablecimiento('400ms', '200ms', establecimiento);
          });
          // Cierra el infowindow actual antes de abrir uno nuevo
          /*if (this.currentInfoWindow) {
            this.currentInfoWindow.close();
          }
          infowindow.setContent(
            `<app-info-window-content 
            [establecimientoName]="establecimiento.est_name" 
            [establecimientoImgSrc]="establecimiento.est_imgs ? '${this.urlBase}/uploads/imgs/${establecimiento.est_imgs}' : 'assets/images/icons8-not-found-96.png'">
            </app-info-window-content>`
            /*`<div class="window-container">
              <div class="contenido-establecimiento1">
                <h2 style="margin-bottom: 15px; font-size: 18px; font-weight: 500;">${establecimiento.est_name}</h2>
                <img src="${establecimiento.est_imgs ? `${this.urlBase}/uploads/imgs/${establecimiento.est_imgs}` : 'assets/images/icons8-not-found-96.png'}" 
                style="height: 150px; margin-left: 20px; margin-right: 20px;">
              </div>
            </div>
            <div class="contenido-establecimiento2" style="margin-top: 15px; padding-bottom: 10px;">
              <a href = "/establecimiento/${establecimiento.id}" style="box-shadow: none;" margin-left: 10px;">
                <span style="font-size: 17px; font-weight: 500">Ver</span>
              </a>
              <a [style.display]="${this.permiso} ? 'block' : 'none'" href="/${establecimiento.id}/editar/establecimiento"
              style="margin-left: 10px;">
                <span style="font-size: 17px; font-weight: 500">Editar</span>
              </a>
              <a mat-mini-fab matTooltip="Ver en Google Maps" color="warn" aria-label="Ver en Google Maps" 
              href="https://www.google.com/maps/search/?api=1&query=${establecimiento.est_lat},${establecimiento.est_lng}" target="_blank"
              style="box-shadow: none; margin-left: 10px;">
                <span style="font-size: 17px; font-weight: 500">Mapa</span>
              </a>
            </div>`
          );
          /*console.log(`${this.urlBase}/uploads/imgs/${establecimiento.est_imgs}`);
          console.log(`/establecimiento/${establecimiento.id}`);
          console.log(`https://www.google.com/maps/search/?api=1&query=${establecimiento.est_lat},${establecimiento.est_lng}`)

          infowindow.open(map, marker);
          this.currentInfoWindow = infowindow;*/
        });
        this.markers.push(marker);
      });
      //new MarkerClusterer({ this.markers, map });
    } else {
      console.error('Elemento del mapa no encontrado en el DOM.');
    }
  }

  /*async closeInfoWindow(): Promise<void> {
    if (this.infoWindowOpened) {
      return new Promise<void>((resolve) => {
        this.infoWindowOpened?.close();
        resolve();
      });
    }
  }*/

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  ngOnDestroy(): void {
    if (this.establecimientoSubscription) {
      this.establecimientoSubscription.unsubscribe();
    } 
  }

  /*close_window(){
    if (this.previous_info_window != null ) {
      this.previous_info_window.close()
      }    
    }
  */
    
  select_marker(establecimiento: any){
    console.log(establecimiento.est_name);
     /*if (this.previous_info_window == null)
      this.previous_info_window = infoWindow;
     else{
      this.infoWindowOpened = infoWindow
      this.previous_info_window.close()
     }
     this.previous_info_window = infoWindow
    }*/
  }

  abrirDialogoEstablecimiento(enterAnimationDuration: string, exitAnimationDuration: string, establecimiento: any){
    this.dialog.open(InfoWindowDialog, {
      data: establecimiento,
      width: '600px',
      enterAnimationDuration,
      exitAnimationDuration,
    });
  }

}

@Component({
  selector: 'info-window-dialog',
  templateUrl: 'info-window-dialog.html',
  styleUrls: ['./info-window-dialog.css'],
  standalone: true,
  imports: [
    MatDialogModule, 
    MatFormFieldModule, 
    MatInputModule, 
    FormsModule, 
    MatButtonModule, 
    NgFor, 
    NgIf, 
    MatDividerModule, 
    CommonModule,
    MatIconModule,
    RouterModule
  ],
})
export class InfoWindowDialog {
  
  userData: any = [];
  urlBase: string = "";
  imgURL: string = "";
  addressData: any;

  constructor(public dialogRef: MatDialogRef<InfoWindowDialog>, @Inject(MAT_DIALOG_DATA) public establecimiento: any, 
  private userDataService: UserDataService, private router: Router,
  private changeDetector: ChangeDetectorRef){
    this.userData = this.userDataService.getUserData();
    this.urlBase = environment.urlNonce;
    if(this.userData.pro_id == 4 || this.userData.pro_id == 1){
    }
    if(establecimiento.est_imgs == null){
      this.imgURL = "assets/images/icons8-not-found-96.png";
    } else {
      this.imgURL = this.urlBase + "/uploads/imgs/" + establecimiento.est_imgs;
    }
    console.log(establecimiento);
    this.getAddress(establecimiento.est_lat, establecimiento.est_lng);
    console.log(this.addressData);
  }

  cerrarDialogo() {
    this.dialogRef.close();
  }

  verEstablecimiento(establecimientoID: number) {
    this.router.navigate(['/establecimiento', establecimientoID]);
    this.cerrarDialogo();
  }
  
  editarEstablecimiento(establecimientoID: number) {
    this.router.navigate([`/${establecimientoID}/editar/establecimiento`]);
    this.cerrarDialogo();
  }

  verEnMaps(establecimiento: any): void {
    const url = `https://www.google.com/maps/search/?api=1&query=${establecimiento.est_lat},${establecimiento.est_lng}`;
    window.open(url, '_blank');
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      //la posicion 0 es el lugar más cercano al click
      if(response.results[0]) {
        this.addressData = response.results[0].formatted_address;
        console.log(this.addressData);
      } else{
        this.addressData = "No hay resultados";
      }
    });
  }
  
}
